export default __webpack_public_path__ + "static/media/personal.c034f716.svg";